export const GET_COMPANY_ACTIVITY_LOGS_REQUEST =
  "GET_COMPANY_ACTIVITY_LOGS_REQUEST";
export const GET_COMPANY_ACTIVITY_LOGS_RESPONSE =
  "GET_COMPANY_ACTIVITY_LOGS_RESPONSE";
export const GET_COMPANY_ACTIVITY_LOGS_FAILURE =
  "GET_COMPANY_ACTIVITY_LOGS_FAILURE";
